<script>

export default {
  name: 'Mention'
};
</script>

<template>
  <div class="content">
    <h2 class="primary--text mb-6">
      Contacts
    </h2>
    <h3>Contactez le service commande</h3>
    <br>
    <p>
      Par téléphone, de 7h30 à 12h et de 13h à 18h :<br>
      <b>09 70 80 99 97</b>
    </p>
    <br>
    <p>
      Ou par mail :<br>
      <b><a href="mailto:commandealiment.usine@agrial.com">commandealiment.usine@agrial.com</a></b>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.content {
  margin: 3vw;
  padding: 2vw;
  background-color: #f4f8f9;
}
</style>
